import { render } from "./AddOrEditStockProductPage.vue?vue&type=template&id=5b1cfc00&ts=true"
import script from "./AddOrEditStockProductPage.vue?vue&type=script&lang=ts"
export * from "./AddOrEditStockProductPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__